/**
 * Ивенты товара и корзины
 */
const viewedEcommerceProductElements = new WeakSet();

function getEcommerceProductNode(element) {
    return element ? element.closest('[data-ecommerce-product]') : null;
}

function getEcommerceProductData(element) {
    const productNode = getEcommerceProductNode(element);
    if (!productNode || !productNode.dataset.ecommerceProduct) {
        return null;
    }

    try {
        const product = JSON.parse(productNode.dataset.ecommerceProduct);
        return product && product.id && product.name ? product : null;
    } catch (error) {
        return null;
    }
}

function getEcommerceProductListName(element) {
    if (element.closest('.related-products')) {
        return 'Похожие товары';
    }

    if (element.closest('.mini-cart-related-products')) {
        return 'Может вам пригодиться';
    }

    const heading = document.querySelector('.woocommerce-products-header__title, .nm-shop-heading h1, h1');
    return heading ? heading.textContent.trim() : 'Список товаров';
}

function prepareEcommerceProduct(product, element, index = null) {
    const preparedProduct = {
        id: product.id,
        name: product.name,
        price: product.price,
        brand: product.brand,
        category: product.category
    };

    if (product.quantity) {
        preparedProduct.quantity = product.quantity;
    }

    const listName = getEcommerceProductListName(element);
    if (listName) {
        preparedProduct.list = listName;
    }

    if (index !== null) {
        preparedProduct.position = index + 1;
    }

    return preparedProduct;
}

function pushEcommerceProductDetail() {
    if (window.lavsitEcommerceDetailPushed) {
        return;
    }

    const detailNode = document.querySelector("[data-ecommerce-detail-product]");
    if (!detailNode || !detailNode.dataset.ecommerceDetailProduct) {
        return;
    }

    try {
        const product = JSON.parse(detailNode.dataset.ecommerceDetailProduct);
        if (!product || !product.id || !product.name) {
            return;
        }

        (window.dataLayer = window.dataLayer || []).push({
            ecommerce: {
                currencyCode: "RUB",
                detail: {
                    products: [
                        {
                            id: product.id,
                            name: product.name,
                            price: product.price,
                            brand: product.brand,
                            category: product.category
                        }
                    ]
                }
            }
        });
        window.lavsitEcommerceDetailPushed = true;
    } catch (error) {
        return;
    }
}

function pushEcommerceProductImpressions(root = document) {
    const productNodes = Array.from(root.querySelectorAll('[data-ecommerce-product]'))
        .filter(productNode => !viewedEcommerceProductElements.has(productNode));

    const products = productNodes
        .map((productNode, index) => {
            viewedEcommerceProductElements.add(productNode);
            const product = getEcommerceProductData(productNode);
            return product ? prepareEcommerceProduct(product, productNode, index) : null;
        })
        .filter(Boolean);

    if (!products.length) {
        return;
    }

    (window.dataLayer = window.dataLayer || []).push({
        ecommerce: {
            currencyCode: 'RUB',
            impressions: products
        }
    });
}

function initEcommerceProducts() {
    pushEcommerceProductDetail();
    pushEcommerceProductImpressions();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEcommerceProducts);
} else {
    initEcommerceProducts();
}

document.body.addEventListener('click', event => {
    const link = event.target.closest('a');
    const productNode = getEcommerceProductNode(link);
    const product = getEcommerceProductData(productNode);

    if (!link || !productNode || !product) {
        return;
    }

    (window.dataLayer = window.dataLayer || []).push({
        ecommerce: {
            currencyCode: 'RUB',
            click: {
                actionField: {
                    list: getEcommerceProductListName(productNode)
                },
                products: [
                    prepareEcommerceProduct(product, productNode)
                ]
            }
        }
    });
});

jQuery(document.body).on('post-load yith-wcan-ajax-filtered yith_infs_added woof_ajax_done', () => {
    pushEcommerceProductImpressions();
});

//Показываем товар
jQuery(document.body).on('show_product', (event, data) => {
    (dataLayer = window.dataLayer || []).push({
        ecommerce: {
            currencyCode: "RUB",
            detail: {
                products: [
                    {
                        id: data['id'],
                        name: data['name'],
                        price: data['price'],
                        brand: data['brand'],
                        category: data['category']
                    }
                ]
            }
        }
    });

    _tmr.push({ type: 'reachGoal', id: 3663856, value: 'VALUE', goal: 'viewProduct', params: {
        product_id: data['sku'].replaceAll('.', '-')
    }});
});

//Добавление товара в корзину
jQuery(document.body).on('added_to_cart', (event, fragments) => {
    if (fragments['metric']) {
        (window.dataLayer = window.dataLayer || []).push({
            "ecommerce": {
                "currencyCode": "RUB",
                "add": {
                    "products": [
                        {
                            "id": fragments['metric']['id'],
                            "name": fragments['metric']['name'],
                            "price": fragments['metric']['price'],
                            "brand": fragments['metric']['brand'],
                            "category": fragments['metric']['category'],
                            "quantity": fragments['metric']['quantity']
                        }
                    ]
                }
            }
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, value: 'VALUE', goal: 'addToCart', params: {
            product_id: fragments['metric']['sku'].replaceAll('.', '-')
        }});
    }
});

//Удаление товара из корзины
jQuery(document.body).on('removed_from_cart', (event, fragments) => {
    if (fragments['metric']) {
        (window.dataLayer = window.dataLayer || []).push({
            "ecommerce": {
                "currencyCode": "RUB",
                "remove": {
                    "products": [
                        {
                            "id": fragments['metric']['id'],
                            "name": fragments['metric']['name'],
                            "price": fragments['metric']['price'],
                            "brand": fragments['metric']['brand'],
                            "category": fragments['metric']['category'],
                            "quantity": fragments['metric']['quantity']
                        }
                    ]
                }
            }
        });
    }
});

//Заказ оформлен
jQuery(document.body).on('product_ordered', (event, data) => {
    (dataLayer = window.dataLayer || []).push({
        ecommerce: {
            currencyCode: "RUB",
            purchase: {
                actionField: {
                    id: data['order_id'],
                    revenue: data['total_price']
                },
                products: data['products'].map(({ id, name, price, brand, category, quantity }) =>
                    ({ id, name, price, brand, category, quantity }))
            }
        }
    });

    data['products'].forEach((product) => {
        _tmr.push({ type: 'reachGoal', id: 3663856, value: 'VALUE', goal: 'purchase', params: {
            product_id: product['sku'].replaceAll('.', '-')
        }});
    });
});


/**
 * Ивенты попапов
 */
//Ивент открытия формы "Обратного звонка"
document.body.addEventListener('click', event => {
    if (event.target.closest('.popmake-51598.pum-trigger')) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'callback',
            'eventAction': 'openform',
            'eventLabel': ''
        });
    }
});

//Ивент открытия формы "Оформить заявку" (Помощь с заказом)
document.body.addEventListener('click', event => {
    if (event.target.closest('.popmake-56288.pum-trigger')) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'order_submit',
            'eventAction': 'openform',
            'eventLabel': ''
        });
    }
});

//Ивент открытия формы "Получить 3D модель"
document.body.addEventListener('click', event => {
    if (event.target.closest('.popmake-56287.pum-trigger')) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': '3d_model',
            'eventAction': 'openform',
            'eventLabel': ''
        });
    }
});

//Ивент открытия формы "Написать руководству"
document.body.addEventListener('click', event => {
    if (event.target.closest('.popmake-51605.pum-trigger')) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'contact_manager',
            'eventAction': 'openform',
            'eventLabel': ''
        });
    }
});

//Ивент открытия окна «Причины» из верхнего бара
document.body.addEventListener('click', event => {
    if (event.target.closest('a[href="#top-bar-reasons"]')) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'top_bar_reasons',
            'eventAction': 'openform',
            'eventLabel': ''
        });
    }
});

/**
 * Ивенты форм
 */
//Ивент отправки формы "Обратного звонка"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 51597) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'callback',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'lead_designer'});
    }
});

//Ивент отправки формы "Оформить заявку" (Помощь с заказом)
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56231) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'order_submit',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Получить 3D модель"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56232) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': '3d_model',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "3D визуализация"
document.addEventListener('wpcf7mailsent', event => {
    if (event.target.closest('.v3d-contact')) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'visualization',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Отправить проект, b2b"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 127558) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'project_coop',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Форма консультации" (Нужна консультация?)
document.addEventListener('wpcf7mailsent', event => {
    if ((event['detail']['contactFormId'] === 52000) || (event['detail']['contactFormId'] === 101216)) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'consultation',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Расчет дивана на заказ, квиз"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56236) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'quiz-sofa',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Расчет кровати на заказ, квиз"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56237) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'quiz-bed',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Расчет стульев на заказ, квиз"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56238) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'quiz-chair',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Запрос нестандартного размера, каталог и КТ"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56234) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'unique-size',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Заявка на индивидуальный расчет дивана"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 63478) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'calculation',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Получить базу 3Д моделей"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 56233) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'get_3d_model_base',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Получить базу 3Д моделей"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 51604) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'contact_manager',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы "Заказать образцы ткани"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 65445) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'fabric_samples',
            'eventAction': 'sentform',
            'eventLabel': ''
        });

        _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'sendForm'});
    }
});

//Ивент отправки формы из окна «Причины» из верхнего бара
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 148441) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'top_bar_reasons',
            'eventAction': 'sentform',
            'eventLabel': ''
        });
    }
});

//Ивент отправки формы из попапа "Быстрый заказ"
document.addEventListener('wpcf7mailsent', event => {
    if (event['detail']['contactFormId'] === 148974) {
        (window.dataLayer = window.dataLayer || []).push({
            'event':'YMevent',
            'eventCategory': 'quick_buy',
            'eventAction': 'sentform',
            'eventLabel': ''
        });
    }
});

let social = ["//t.me/", "//api.whatsapp.com/", "//max.ru/"];
jQuery("a").on('click', (evt, data) => {
    social.forEach((element, index, array) => {
        if (evt.currentTarget.href.includes(element)) {
            _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'clickMessenger'});
        }
    });
});

// Клик по ссылкам с переходом на страницу дизайнеров.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a.designers-link, .designers-link a').forEach((link) => {
        link.addEventListener('click', () => {
            _tmr.push({ type: 'reachGoal', id: 3663856, goal: 'click_designers'});
        });
    });
});

//события новой КТ
document.addEventListener('DOMContentLoaded', () => {
    let isNewProductPageTemplate = document.querySelector("body.product-template-new-product-page");

    //1 Переходы между экранами на новой карточке товара
    let eventBlocks = document.querySelectorAll("[data-event-label]");
    if (isNewProductPageTemplate && eventBlocks.length) {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if ((window.innerWidth < 1240) && entry.isIntersecting) {
                    (window.dataLayer = window.dataLayer || []).push({
                        'event':'YMevent',
                        'eventCategory': 'product_section',
                        'eventAction': 'view',
                        'eventLabel': entry.target.dataset.eventLabel
                    });
                }
            });
        }, observerOptions);

        eventBlocks.forEach(section => {
            observer.observe(section);
        });
    }

    //2 Клики по мессенджерам в блоке “Дизайнерам”
    let designersSocialLinks = document.querySelectorAll(".product-for-designers .product-for-designers__social-link");
    if (isNewProductPageTemplate && designersSocialLinks.length) {
        designersSocialLinks.forEach(link => {
            link.addEventListener('click', (evt) => {
                (window.dataLayer = window.dataLayer || []).push({
                    'event':'YMevent',
                    'eventCategory': 'design_message',
                    'eventAction': 'click',
                    'eventLabel': ''
                });
            })
        })
    }

    //3 Клики по мессенджерам в табе “Гарантия”
    let warrantySocialLinks = document.querySelectorAll(".product-tabs-new .product-tabs-new__button");
    if (isNewProductPageTemplate && warrantySocialLinks.length) {
        warrantySocialLinks.forEach(link => {
            link.addEventListener('click', (evt) => {
                (window.dataLayer = window.dataLayer || []).push({
                    'event':'YMevent',
                    'eventCategory': 'warranty_message',
                    'eventAction': 'click',
                    'eventLabel': ''
                });
            })
        })
    }

    //4 Клики по табам “Односпальная/Двуспальная”
    let productVariationsFilterButtons = document.querySelectorAll(".product-variations-cards__filter");
    if (isNewProductPageTemplate && productVariationsFilterButtons.length) {
        productVariationsFilterButtons.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                (window.dataLayer = window.dataLayer || []).push({
                    'event':'YMevent',
                    'eventCategory': 'switch_bed_type',
                    'eventAction': 'click',
                    'eventLabel': ''
                });
            })
        })
    }

    //5 Взаимодействие с галереей “Похожие товары” мобильной версии
    let promoSliderNavBtn = document.querySelectorAll(".bedroom-promo .slider-nav__btn");
    if (isNewProductPageTemplate && promoSliderNavBtn.length) {
        promoSliderNavBtn.forEach(btn => {
            btn.addEventListener('click', () => {
                (window.dataLayer = window.dataLayer || []).push({
                    'event':'YMevent',
                    'eventCategory': 'related_swipe',
                    'eventAction': 'click',
                    'eventLabel': ''
                });
            })
        })
    }


    //6 Клики по табам характеристик товара
    let productTabsItems = document.querySelectorAll(".product-tabs-new__menu-item");
    if (isNewProductPageTemplate && productTabsItems.length) {
        productTabsItems.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                (window.dataLayer = window.dataLayer || []).push({
                    'event':'YMevent',
                    'eventCategory': 'product_info_tab',
                    'eventAction': 'click',
                    'eventLabel': evt.target.innerHTML
                });
            })
        })
    }
});


